module.exports = __webpack_public_path__ + "static/media/refresh.8bb4e587.svg";